import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CloneProjectDto, ProjectDto } from 'projects/shared/src/lib/models/Project';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { ProjectService } from 'projects/shared/src/lib/services/project.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'clone-project-dialog',
  templateUrl: './clone-project-dialog.component.html',
  styleUrls: ['./clone-project-dialog.component.scss']
})
export class CloneProjectDialogComponent implements OnInit {

  cloneProjectForm!:FormGroup;
  _db!:string;

  constructor(private formBuilder: FormBuilder,
    public _dialogRef: MatDialogRef<CloneProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private projectService: ProjectService,
    private oauthService: OAuthServiceService,
    private tenantService: TenantService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((role: string) => {
            if (role === 'admin') {
              this._db = role;
            }
          });
        }
      }
    });
    this.createcloneProjectForm();
  }

  createcloneProjectForm(){
    this.cloneProjectForm = this.formBuilder.group({
      name: [null, Validators.required]
    });
  }

  createCloneProject(){

    if(this.cloneProjectForm.valid) {

      let cloneProject = new CloneProjectDto;
      cloneProject.projectId = this.data[0].id;
      cloneProject.name = this.cloneProjectForm.value.name;

      // if(this._db){
      //   this.cloneInMainDb(cloneProject);
      // }
      // else{
        this.cloneInTenantDb(cloneProject);
      // }
    }
  }

  cloneInTenantDb(cloneProject: CloneProjectDto) {
    let db:string = this.tenantService.currentTenantName;
    this.tenantService.cloneProject(db, cloneProject).subscribe({
        next:(project) => {
          this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTCLONED"]} `);
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTCLONEDERROR"]}`)
      })
  }

  // cloneInMainDb(cloneProject: CloneProjectDto) {
  //   this.projectService.cloneProject(cloneProject).subscribe({
  //     next:(project) => {
  //       this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTCLONED"]} `);
  //     },
  //     error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTCLONEDERROR"]}`)
  //   })
  // }

}